// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Galeria_GenerateSingleThumbnailResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Galeria_GenerateSingleThumbnailResponseDados {
id: number
nome: string
status: string
message: string
}

export type Galeria_GenerateSingleThumbnailResponse = ApiResponse<Galeria_GenerateSingleThumbnailResponseDados>;

registerResponseContract('Galeria_GenerateSingleThumbnailResponse', {
  id:      { type: 'number',  required: true },
  nome:    { type: 'string',  required: true },
  status:  { type: 'string',  required: true },
  message: { type: 'string',  required: true },
})
